import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import { useRef } from "react";

const ForgetTrainingDialog = ({
  isOpen,
  onClose,
  onConfirm,
}: ForgetTrainingDialogProps) => {
  const cancelRef = useRef(null);
  const handleDelete = () => {
    onConfirm();
    onClose();
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Dimentica training
          </AlertDialogHeader>

          <AlertDialogBody>
            Sei sicuro di voler dimenticare questo training?
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              Annula
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3}>
              Dimentica
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default ForgetTrainingDialog;

interface ForgetTrainingDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}
